import React from "react";
import styles from "./Loader.local.scss";

const Loading = () => {
  return (
    <div className={styles.loadingPage}>
      <svg
        width='150px'
        height='150px'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 100 100'
        preserveAspectRatio='xMidYMid'
      >
        <circle
          cx='50'
          cy='50'
          r='8.3023'
          fill='none'
          ng-attr-stroke='{{config.c1}}'
          ng-attr-stroke-width='{{config.width}}'
          stroke='#F29651'
          stroke-width='3'
        >
          <animate
            attributeName='r'
            calcMode='spline'
            values='0;40'
            keyTimes='0;1'
            dur='1'
            keySplines='0 0.2 0.8 1'
            begin='-0.5s'
            repeatCount='indefinite'
          ></animate>
          <animate
            attributeName='opacity'
            calcMode='spline'
            values='1;0'
            keyTimes='0;1'
            dur='1'
            keySplines='0.2 0 0.8 1'
            begin='-0.5s'
            repeatCount='indefinite'
          ></animate>
        </circle>
        <circle
          cx='50'
          cy='50'
          r='29.5962'
          fill='none'
          ng-attr-stroke='{{config.c2}}'
          ng-attr-stroke-width='{{config.width}}'
          stroke='#5282BC'
          stroke-width='3'
        >
          <animate
            attributeName='r'
            calcMode='spline'
            values='0;40'
            keyTimes='0;1'
            dur='1'
            keySplines='0 0.2 0.8 1'
            begin='0s'
            repeatCount='indefinite'
          ></animate>
          <animate
            attributeName='opacity'
            calcMode='spline'
            values='1;0'
            keyTimes='0;1'
            dur='1'
            keySplines='0.2 0 0.8 1'
            begin='0s'
            repeatCount='indefinite'
          ></animate>
        </circle>
      </svg>
    </div>
  );
};

export default Loading;